import Promise from 'bluebird'

export default {
  login() {
    return new Promise((resolve, reject) => {
      window.FB.login(
        (loginResponse) => {
          if (loginResponse.authResponse) {
            resolve(loginResponse)
          } else {
            reject()
          }
        },
        {
          scope: 'email',
        }
      )
    })
  },

  init(pixelId) {
    console.log('FBQ INIT', pixelId)

    window.fbq('init', pixelId)
  },

  track(pixelId, event, options) {
    console.log('FBQ TRACK', pixelId, event, options)

    try {
      window.fbq('init', pixelId)
      window.fbq('track', event, options)
    } catch (e) {
      console.log(e) //eslint-disable-line
    }
  },
}



// WEBPACK FOOTER //
// ./src/lib/facebook.js